import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPeopleInterestAsync, deletePeopleInterestAsync, getPeopleInterestByIdAsync, getPeopleInterestsByPeopleIdAsync, updatePeopleInterestAsync } from './peopleInterestsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const peopleInterestsSlice = createSlice({
    name: 'peopleInterests',
    initialState,
    reducers: {
        resetPeopleInterestsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createPeopleInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPeopleInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleInterest = action.payload;
            if (state.peopleInterests && Array.isArray(state.peopleInterests)) {
                state.peopleInterests.push(action.payload);
            }
        })
            .addCase(createPeopleInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Update
            .addCase(updatePeopleInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePeopleInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleInterest = action.payload;
            if (state.peopleInterests && Array.isArray(state.peopleInterests)) {
                const idx = state.peopleInterests.findIndex((x) => x.id === action.payload.id);
                if (idx >= 0)
                    state.peopleInterests[idx] = action.payload;
            }
        })
            .addCase(updatePeopleInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Delete
            .addCase(deletePeopleInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePeopleInterestAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deletePeopleInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Id
            .addCase(getPeopleInterestByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPeopleInterestByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleInterest = action.payload;
        })
            .addCase(getPeopleInterestByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By People Id
            .addCase(getPeopleInterestsByPeopleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPeopleInterestsByPeopleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedPeopleInterests = action.payload;
        })
            .addCase(getPeopleInterestsByPeopleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetPeopleInterestsApiState } = peopleInterestsSlice.actions;
export default peopleInterestsSlice.reducer;
